module.exports = __webpack_public_path__ + "static/Tina.3691176a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Tina.jpg
// module id = 1327
// module chunks = 137408898365125